export default "__VITE_ASSET__Dzur5IRK__"